import React, {useRef, useState} from "react";
import {uploadMedia} from "../api/media";
import {fileName, mediaUrl} from "./media";

/** One document (brochure or floor plan: PDF or image). `value` is its stored path, `onChange` gets the new one. */
const DocumentUpload = ({value, onChange, label = "Upload PDF", accept = "application/pdf,image/jpeg,image/png"}) => {
    const input = useRef(null);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState("");

    const pick = async (files) => {
        const file = files?.[0];
        if (!file) return;
        setBusy(true);
        setError("");
        try {
            const [uploaded] = await uploadMedia([file], "document");
            onChange(uploaded.path);
        } catch (err) {
            setError(err.message);
        } finally {
            setBusy(false);
            if (input.current) input.current.value = "";
        }
    };

    return (
        <div className="brk-doc">
            {value ? (
                <div className="brk-doc__file">
                    <a href={mediaUrl(value)} target="_blank" rel="noreferrer">📄 {fileName(value)}</a>
                    <button type="button" className="brk-link" onClick={() => input.current?.click()} disabled={busy}>
                        Replace
                    </button>
                    <button type="button" className="brk-link brk-link--danger" onClick={() => onChange("")}>Remove</button>
                </div>
            ) : (
                <button type="button" className="brk-btn brk-btn--ghost brk-btn--sm" disabled={busy}
                        onClick={() => input.current?.click()}>
                    {busy ? "Uploading…" : label}
                </button>
            )}
            <input ref={input} type="file" accept={accept} hidden onChange={(e) => pick(e.target.files)}/>
            {error && <p className="brk-field__error" role="alert">{error}</p>}
        </div>
    );
};

export default DocumentUpload;
